import { render, staticRenderFns } from "./LogoModal.vue?vue&type=template&id=850a946c&scoped=true"
import script from "./LogoModal.vue?vue&type=script&lang=js"
export * from "./LogoModal.vue?vue&type=script&lang=js"
import style0 from "./LogoModal.vue?vue&type=style&index=0&id=850a946c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850a946c",
  null
  
)

export default component.exports